import Card from "@material-ui/core/Card";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles({
  root: {
    minHeight: "400px",
    border: "none",
    boxShadow: "none",
    padding: "20px",
    maxWidth: "550px",
    margin: "20px",
    backgroundColor: "transparent",
  },
  media: {
    borderRadius: "5px",
    width: "100%",
    height: "300px",
    maxWidth: "500px",
    maxHeight: "350px",
    margin: "auto",
  },
  cardBody: {
    minHeight: "325px",
    backgroundColor: "transparent",
  },
  typographyStyle: {
    fontFamily: "Open Sans light",
    fontSize: "30px",
    letterSpacing: "1px",
    marginTop: "10px",
    color: "#000000",
  },
  p: {
    fontFamily: "Lora",
    fontSize: "15px",
    color: "#aaaaaaa",
  },
  h2: {
    fontFamily: "Open Sans",
    fontSize: "18px",
    color: "#aaaaaa",
    textTransform: "uppercase",
    letterSpacing: "2px",
    paddingBottom: "4px",
  },
});

const CustomCard = (props) => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        <CardMedia
          component="img"
          alt="article"
          image={props.img}
          title={props.desc}
          className={classes.media}
        />
      </a>
      <CardContent className={classes.cardBody}>
        <a
          href={props.link}
          className="titlelink"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            className={classes.typographyStyle}
          >
            {props.title}
          </Typography>
        </a>
        <Typography
          gutterBottom
          variant="h5"
          component="h2"
          className={classes.h2}
        >
          {props.author}
        </Typography>
        <Typography variant="body2" color="textSecondary" className={classes.p}>
          {props.desc}
        </Typography>
      </CardContent>

      <CardActions>
        <Button
          variant="contained"
          style={{
            color: "white",
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), #374567",
          }}
          size="large"
          disableElevation
          onClick={(e) => {
            e.preventDefault();
            window.open(`${props.link}`, "_blank", "noopener");
          }}
        >
          Read <ChevronRightIcon />{" "}
        </Button>
      </CardActions>
    </Card>
  );
};

export default CustomCard;
